<template>
    <SelectAsync
        :label="label"
        :optionsValue="optionsValueComponent"
        :optionsLabel="optionsLabelComponent"
        :options="optionsComponent"
        endpoint="/fields"
        :fetchConfig="{
            baseURL: ApiCore,
        }"
        :value.sync="valueComponent"
        :typeSelect="typeSelect"
        :size="size"
        :placeholder="placeholder"
        :horizontal="horizontal"
        :formatOptions="formatOptions"
    />
</template>

<script>
/** Components */
import SelectAsync from "£lement/SelectAsync";

/** Mixins */
import baseMixin from "~/mixins/base";

/** Others */
import { mapGetters } from "vuex";

export default {
    name: "SelectFields",
    mixins: [baseMixin],
    components: {
        SelectAsync,
    },
    props: {
        isValid: {
            type: Boolean,
            default: null,
        },
        label: {
            type: String,
            default: null,
        },
        value: {
            default: null,
        },
        horizontal: {
            default: false,
        },
        placeholder: {
            type: String,
            default: null,
        },
        size: {
            default: undefined,
        },
        optionsValue: {
            default: "id",
        },
        optionsLabel: {
            default: "name",
        },
        typeSelect: {
            default: "CSelect",
        },
        formatOptions:{
            type: Function,
        },
        uses:{
            default: "ALL"
        }
    },
    data() {
        return {
            valueComponent: this.value,
            optionsComponent: [],
            optionsValueComponent: this.optionsValue,
            optionsLabelComponent: this.optionsLabel,
        };
    },
    computed: {
        ...mapGetters({
            storeGlobalFieldsAdvance: "global/fieldsAdvance",
        }),
    },
    watch: {
        optionsValue() {
            this.optionsValueComponent = this.optionsValue;
        },
        optionsLabel() {
            this.optionsLabelComponent = this.optionsLabel;
        },
        value() {
            this.valueComponent = this.value;
        },
        valueComponent() {
            this.$emit("update:value", this.valueComponent);
        },
        optionsComponent() {
            // this.storeFields();
        },
    },
    methods: {
        storeFields: async function () {
            this.$store.dispatch("global/saveFieldsAdvance", {
                fields: this.optionsComponent
            });
        },
    },
    created(){
        if(this.storeGlobalFieldsAdvance.length > 0){
            this.optionsComponent = this.storeGlobalFieldsAdvance.filter(
                field => this.listToArray(field.uses).includes(this.uses)
                    || this.listToArray(field.uses).includes("ALL")
            );
        }

    }
};
</script>
<style>
</style>